import { ChangeDetectionStrategy, Component, ElementRef, Renderer2 } from '@angular/core';
import { PrintCardContentComponent } from '../../shared/print-card-content.component';
import { GenericPostCardStackContentViewModel } from './generic-post-card-stack-content-view-model';

@Component({
  selector: 'app-generic-post-card-stack-content',
  templateUrl: './generic-post-card-stack-content.component.html',
  styleUrls: ['./generic-post-card-stack-content.component.scss'],
  providers: [GenericPostCardStackContentViewModel],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class GenericPostCardStackContentComponent extends PrintCardContentComponent {
  constructor(
    public override viewModel: GenericPostCardStackContentViewModel,
    elementRef: ElementRef,
    renderer2: Renderer2
  ) {
    super(viewModel, elementRef, renderer2);
  }
}
